import React, { Fragment, useContext } from "react";
import { observer } from "mobx-react-lite";
import { Store } from "../stores/store-root";

const ModalContainer = () => {
  const root = useContext(Store);
  const {
    modal: { open, body },
    closeModal,
  } = root.Modal;
  return (
   <Fragment>
     {body}
   </Fragment>
    
  );
};

export default observer(ModalContainer);
